import React from "react";

const RoentgenStatistikk = (props) => {
    const statistikk = props.statistikk;
    const raseStatistikk = props.raseStatistikk;

    return (
        <div>
            <table className="table-statistik" cellSpacing="0" cellPadding="0" width="100%">
                <thead>
                <tr>
                    <th className="test-type" width="20%"><strong>HD</strong></th>
                    <th width="15%">Antal</th>
                    <th width="15%">%</th>
                    <th width="40px">Antal</th>
                    <th width="40px">%</th>

                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="test-type">Totalt</td>
                    <td>{statistikk.antallHd}</td>
                    <td>{statistikk.prosentTotalHd}</td>
                    <td>{raseStatistikk.antallHd}</td>
                    <td>{raseStatistikk.prosentTotalHd}</td>
                </tr>
                <tr>
                    <td className="test-type">A</td>
                    <td>{statistikk.hdAntA}</td>
                    <td>{statistikk.prosentHdResultatA}</td>
                    <td>{raseStatistikk.hdAntA}</td>
                    <td>{raseStatistikk.prosentHdResultatA}</td>
                </tr>
                <tr>
                    <td className="test-type">B</td>
                    <td>{statistikk.hdAntB}</td>
                    <td>{statistikk.prosentHdResultatB}</td>
                    <td>{raseStatistikk.hdAntB}</td>
                    <td>{raseStatistikk.prosentHdResultatB}</td>
                </tr>
                <tr>
                    <td className="test-type">C</td>
                    <td>{statistikk.hdAntC}</td>
                    <td>{statistikk.prosentHdResultatC}</td>
                    <td>{raseStatistikk.hdAntC}</td>
                    <td>{raseStatistikk.prosentHdResultatC}</td>
                </tr>
                <tr>
                    <td className="test-type">D</td>
                    <td>{statistikk.hdAntD}</td>
                    <td>{statistikk.prosentHdResultatD}</td>
                    <td>{raseStatistikk.hdAntD}</td>
                    <td>{raseStatistikk.prosentHdResultatD}</td>
                </tr>
                <tr>
                    <td className="test-type">E</td>
                    <td>{statistikk.hdAntE}</td>
                    <td>{statistikk.prosentHdResultatE}</td>
                    <td>{raseStatistikk.hdAntE}</td>
                    <td>{raseStatistikk.prosentHdResultatE}</td>
                </tr>
                <tr>
                    <td colSpan="5">&nbsp;</td>
                </tr>
                <tr>
                    <th className="test-type"><strong>AD</strong></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <tr>
                    <td className="test-type">Totalt</td>
                    <td>{statistikk.antallAd}</td>
                    <td>{statistikk.prosentTotalAd}</td>
                    <td>{raseStatistikk.antallAd}</td>
                    <td>{raseStatistikk.prosentTotalAd}</td>
                </tr>
                <tr>
                    <td>0</td>
                    <td>{statistikk.adAnt0}</td>
                    <td>{statistikk.prosentAdResultat0}</td>
                    <td>{raseStatistikk.adAnt0}</td>
                    <td>{raseStatistikk.prosentAdResultat0}</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>{statistikk.adAnt1}</td>
                    <td>{statistikk.prosentAdResultat1}</td>
                    <td>{raseStatistikk.adAnt1}</td>
                    <td>{raseStatistikk.prosentAdResultat1}</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>{statistikk.adAnt2}</td>
                    <td>{statistikk.prosentAdResultat2}</td>
                    <td>{raseStatistikk.adAnt2}</td>
                    <td>{raseStatistikk.prosentAdResultat2}</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>{statistikk.adAnt3}</td>
                    <td>{statistikk.prosentAdResultat3}</td>
                    <td>{raseStatistikk.adAnt3}</td>
                    <td>{raseStatistikk.prosentAdResultat3}</td>
                </tr>
                <tr>
                    <td colSpan="5">&nbsp;</td>
                </tr>
                <tr>
                    <th className="test-type"><strong>OCD</strong></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <tr>
                    <td className="test-type">Totalt</td>
                    <td>{statistikk.antallOcd}</td>
                    <td>{statistikk.prosentTotalOcd}</td>
                    <td>{raseStatistikk.antallOcd}</td>
                    <td>{raseStatistikk.prosentTotalOcd}</td>
                </tr>
                <tr>
                    <td className="test-type">Fri</td>
                    <td>{statistikk.ocdAntFri}</td>
                    <td>{statistikk.prosentOcdResultatFri}</td>
                    <td>{raseStatistikk.ocdAntFri}</td>
                    <td>{raseStatistikk.prosentOcdResultatFri}</td>
                </tr>
                <tr>
                    <td className="test-type">Påvist</td>
                    <td>{statistikk.ocdAntPaavist}</td>
                    <td>{statistikk.prosentOcdResultatPaavist}</td>
                    <td>{raseStatistikk.ocdAntPaavist}</td>
                    <td>{raseStatistikk.prosentOcdResultatPaavist}</td>
                </tr>
                <tr>
                    <td colSpan="5">&nbsp;</td>
                </tr>
                <tr>
                    <th className="test-type"  colSpan="5"><strong>Aflivet /Opereret pga. svære diagnoser</strong></th>
                </tr>
                <tr>
                    <td className="test-type">HD Opereret</td>
                    <td>{statistikk.antallHdOperertFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallHdOperertFoer12Mnd}</td>
                    <td></td>
                </tr>
                <tr>
                    <td className="test-type">HD Aflivet</td>
                    <td>{statistikk.antallHdAvlivetFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallHdAvlivetFoer12Mnd}</td>
                    <td></td>
                </tr>
                <tr>
                    <td className="test-type">AD Opereret</td>
                    <td>{statistikk.antallAdOperertFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallAdOperertFoer12Mnd}</td>
                    <td></td>
                </tr>
                <tr>
                    <td className="test-type">AD Aflivet</td>
                    <td>{statistikk.antallAdAvlivetFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallAdAvlivetFoer12Mnd}</td>
                    <td></td>
                </tr>
                <tr>
                    <td className="test-type">OCD Opereret</td>
                    <td>{statistikk.antallOcdOperertFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallOcdOperertFoer12Mnd}</td>
                    <td></td>
                </tr>
                <tr>
                    <td className="test-type">OCD Aflivet</td>
                    <td>{statistikk.antallOcdAvlivetFoer12Mnd}</td>
                    <td></td>
                    <td>{raseStatistikk.antallOcdAvlivetFoer12Mnd}</td>
                    <td></td>
                </tr>
                </tbody>
            </table>

        </div>


    );
};
export default RoentgenStatistikk;